import { Card, CardContent, Typography, Select, MenuItem } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { SelectChangeEvent } from "@mui/material/Select";

type AnalyticsTwoLevelPieProps = {
  data1: { label: string; value: number }[];
  data2: { label: string; value: number }[];
  title: string;
  filters: string[];
  selectedProduct: string | null;
  onProductChange: (event: SelectChangeEvent<string>) => void;
};

const AnalyticsTwoLevelPie: React.FC<AnalyticsTwoLevelPieProps> = ({
  data1,
  data2,
  title,
  filters,
  selectedProduct,
  onProductChange,
}) => {
  return (
    <Card>
      <CardContent>
        {title && (
          <Typography variant="h6" component="h2" gutterBottom>
            {title}
          </Typography>
        )}
        <Select
          value={selectedProduct || ""}
          onChange={onProductChange}
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>
            Select a product
          </MenuItem>
          {filters.map((filter) => (
            <MenuItem key={filter} value={filter}>
              {filter}
            </MenuItem>
          ))}
        </Select>
        <PieChart
          series={[
            {
              innerRadius: 0,
              outerRadius: 80,
              data: data1,
            },
            {
              innerRadius: 100,
              outerRadius: 120,
              data: data2,
            },
          ]}
          width={400}
          height={300}
          slotProps={{
            legend: { hidden: true },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default AnalyticsTwoLevelPie;
